import { useState, useMemo } from 'react'
import { WarningAmber } from '@mui/icons-material'
import { Popover, Typography, Paper } from '@mui/material'
import styles from './ReportPage.module.scss'

const ReportIssue = ({issues}) => {
    const [anchorEl, setAnchorEl] = useState(null)

    const handlePopoverOpen = (event) => setAnchorEl(event.currentTarget)
    
    const handlePopoverClose = () => setAnchorEl(null)

    const issuesText = useMemo(() => (
        <Paper elevation={12} classes={{root: styles['issue-paper']}}>
            <Typography classes={{root: styles['issue-text']}}>Issues:</Typography>
            {issues?.map(issue => <Typography classes={{root: styles['issue-text']}} key={issue}>• {issue}</Typography>)}
        </Paper>
    ),[issues]) 

    return (
        <>
            {issues?.length ?
                <> 
                    <WarningAmber
                        classes={{root: styles['issue-icon']}}
                        onMouseEnter={handlePopoverOpen}
                        onMouseLeave={handlePopoverClose}
                        color="warning"
                    />
                    <Popover
                        sx={{ pointerEvents: 'none'}}
                        open={Boolean(anchorEl)}
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        onClose={handlePopoverClose}
                    >
                        {issuesText}
                    </Popover>
                </> : <></>
            }

        </> 
    )
}

export default ReportIssue